export class Order 
{
	constructor()
	{
		let data = $(parent).serialize() + '&action=requestPrice';
		let url = new URL(window.location.href);
		this.share_code = url.searchParams.get('share_code');
	}
	addRoomToCart (id, parent)
	{
		let params = {people: config.people, dates: config.dates};
		this.addToCart('accoms', 'room', id, params, 1, parent);
	}
	addTourToCart (id, parent)
	{
		let params = {people: config.people, date: config.date, time: $('.excursion-times__list input:checked').val(), car: $('.excursion-cars__list input:checked').val()};
		this.addToCart('custom_tours', 'tour', id, params, 1, parent);
	}
	addVisaToCart (parent)
	{
		let count = $('.visa-adding input[name=count]').val();
		let el = $(parent).closest('.visa-adding');
		let params = {urgent: $('.visa-adding .form__choice-list li input:checked').val(), country: el.find('input.form-multi__choice-input:checked').val()};
		this.addToCart('visas', 'visa_types', 3, params, count, $(parent).find('.visa-adding__add'));

		// let num = 0;
		// el.attr('data-value', num);
		// el.find('.visa-adding__counter-value').text(num + '\u00A0шт');
		// el.find('.visa-adding__price').text('$\u00A0' + 0);
	}
	addTransferToCart (parent)
	{
		let _this = this;
		let data = $(parent).serialize() + '&action=addToCart&table=transfer'

		$.ajax({
			url: "/ajax.php?mid=31",
			type: 'POST',
			data: data,
			dataType: "json",
			success: function(res){
				parent.reset();
				_this.updateCart(res.new_count, $(parent).find('.transfers-form__add'));

				if (res.needReturnTransfer)
				{
					if (res.needReturnTransfer == 'Arrival')
					{
						$('.popup-transfer-offer a.btn--Purple').attr('href', '/transfer/?car=' + parent.car.value + '&pickup=' + parent.dropoff.value + '&dropoff=' + parent.pickup.value);
						$('.popup-transfer-offer .transfer-offer-added-type').text('на вылет');
					}
					else
					{
						$('.popup-transfer-offer a.btn--Purple').attr('href', '/transfer/departure/?car=' + parent.car.value + '&pickup=' + parent.dropoff.value + '&dropoff=' + parent.pickup.value);
						$('.popup-transfer-offer .transfer-offer-added-type').text('на прилёт');
					}
					$('.popup-transfer-offer').addClass("active");
					$("body").addClass("no-scroll");
				}

			},
			error: function(err){
				if (err.statusText === "abort") {
			// Запрос был прерван, можно просто проигнорировать
			console.warn('Запрос был прерван.');
		} else {
			// Обработка остальных ошибок
			alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
		}
			}
		});
	}
	addCIPToCart (parent)
	{
		let _this = this;
		let data = $(parent.form).serialize() + '&action=addToCart&table=services'

		$.ajax({
			url: "/ajax.php?mid=31",
			type: 'POST',
			data: data,
			dataType: "json",
			success: function(res){
				_this.updateCart(res.new_count, $(parent));
			},
			error: function(err){
				if (err.statusText === "abort") {
			// Запрос был прерван, можно просто проигнорировать
			console.warn('Запрос был прерван.');
		} else {
			// Обработка остальных ошибок
			alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
		}
			}
		});
	}

	addToCart (table, type, id, params, count, parent)
	{
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=31",
			type: 'POST',
			data: {
				action: 'addToCart',
				table: table, 
				type: type, 
				item: id, 
				count: count, 
				params: params
			},
			dataType: "json",
			success: function(res){
				_this.updateCart(res.new_count, $(parent));
			},
			error: function(err){
				if (err.statusText === "abort") {
			// Запрос был прерван, можно просто проигнорировать
			console.warn('Запрос был прерван.');
		} else {
			// Обработка остальных ошибок
			alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
		}
			}
		});
	}

	timeChanged(parent)
	{
		let hours = $(parent).closest('.form-time').find('.form-time__input--hour').val()
		let minutes = $(parent).closest('.form-time').find('.form-time__input--min').val();
		let dateString = $('#date').val();
		
		const select = document.getElementById('time');
		if (!select) return;
		
		select.innerHTML = ''; // Очистка селекта перед заполнением

		const referenceDate = new Date();
		referenceDate.setHours(hours, minutes, 0, 0);

		const stepMinutes = 30; // Шаг 15 минут
		const startTime = new Date(referenceDate.getTime() - 7.5 * 60 * 60 * 1000); // Минус 5 часов
		const endTime = new Date(referenceDate.getTime() - 2.5 * 60 * 60 * 1000); // Минус 2.5 часа
		const defaultTime = new Date(referenceDate.getTime() - 3 * 60 * 60 * 1000); // Минус 3 часа

		const [day, month, year] = dateString.split('.').map(Number);
		const date = new Date(year, month - 1, day);

		// Уменьшаем дату на 1 день
		date.setDate(date.getDate() - 1);
		let prevDay = date.toLocaleString("ru", {
				month: "long",
				day: "numeric"});
		
		let year2 = date.getFullYear();
		let month2 = String(date.getMonth() + 1).padStart(2, '0');
		let day2 = String(date.getDate()).padStart(2, '0');
		const prevDaySys = `${year2}-${month2}-${day2}`;


		for (let time = startTime; time <= endTime; time.setMinutes(time.getMinutes() + stepMinutes)) {
			const option = document.createElement('option');
			const isPreviousDay = time.getDate() < referenceDate.getDate();
			const formattedTime = `${String(time.getHours()).padStart(2, '0')}:${String(time.getMinutes()).padStart(2, '0')}`;
			option.textContent = isPreviousDay ? `${prevDay} ${formattedTime}` : formattedTime;
			option.value = formattedTime + (isPreviousDay ? `|${prevDaySys}` : '');
			if (time.getTime() === defaultTime.getTime()) {
				option.selected = true;
			}
			select.appendChild(option);
		}
	}

	updateCart(new_count, button)
	{
		$('.header__cart span').text('Корзина: ' + new_count);
		$('.header__cart').addClass('added');

		button.addClass('added');
		button.prop('disabled', true);

		setTimeout(function(){
			$('.header__cart').removeClass('added');
			button.removeClass('added');
			button.prop('disabled', false);
		}, 3000);
	}

	addChoiced(name, value)
	{
		let ul = $('.filters-choiced__list');
		ul.append('<li class="filters-choiced__item"><button class="btn btn--s filters-choiced__item-btn" type="button" data-filter="' + name + '" value="' + value + '" onclick="hotel.deleteChoiced(this);"><span>' + value + '</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M17.7208 6.27916C17.542 6.10042 17.2996 6 17.0467 6C16.7939 6 16.5514 6.10042 16.3726 6.27916L12 10.6518L7.62737 6.27916C7.44857 6.10042 7.2061 6 6.95327 6C6.70044 6 6.45797 6.10042 6.27916 6.27916C6.10042 6.45797 6 6.70044 6 6.95327C6 7.2061 6.10042 7.44857 6.27916 7.62737L10.6518 12L6.27916 16.3726C6.10042 16.5514 6 16.7939 6 17.0467C6 17.2996 6.10042 17.542 6.27916 17.7208C6.45797 17.8996 6.70044 18 6.95327 18C7.2061 18 7.44857 17.8996 7.62737 17.7208L12 13.3482L16.3726 17.7208C16.5514 17.8996 16.7939 18 17.0467 18C17.2996 18 17.542 17.8996 17.7208 17.7208C17.8996 17.542 18 17.2996 18 17.0467C18 16.7939 17.8996 16.5514 17.7208 16.3726L13.3482 12L17.7208 7.62737C17.8996 7.44857 18 7.2061 18 6.95327C18 6.70044 17.8996 6.45797 17.7208 6.27916V6.27916Z" fill="#374957"></path></svg></button></li>');
	}

	removeChoiced(name, value)
	{
		console.log(name);
		console.log(value);
		$('.filters-choiced__list li.filters-choiced__item button[data-filter="' + name + '"][value="' + value + '"]').closest('li').remove();
	}

	removeAllChoiced(name)
	{
		console.log(name);
		$('.filters-choiced__list li.filters-choiced__item button[data-filter="' + name + '"]').closest('li').remove();
	}

	deleteChoiced(parent)
	{
		let el = $(parent);
		let name = el.attr('data-filter');
		let value = el.val();
		$('.filters__choice-list[data-filter="' + name + '"] input[value="' + value + '"]').prop('checked', 0).trigger('change');
	}

	deleteService(parent)
	{
		$.ajax({
			url: "/ajax.php?mid=31",
			type: 'POST',
			data: $(parent).serialize() + '&action=deleteService',
			dataType: "json",
			success: function(res){
				if (res.success)
				{
					location.reload();
				}
				else
				{
					alert('Ошибка: ' + res.error);
				}
			},
			error: function(err){
				if (err.statusText === "abort") {
			// Запрос был прерван, можно просто проигнорировать
			console.warn('Запрос был прерван.');
		} else {
			// Обработка остальных ошибок
			alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
		}
			}
		});
	}

	requestPrice(parent)
	{
		let data = $(parent).serialize() + '&action=requestPrice'
		if (this.share_code)
		{
			data += '&share_code=' + this.share_code;
		}

		$.ajax({
			url: "/ajax.php?mid=31",
			type: 'POST',
			data: data,
			dataType: "json",
			success: function(res){
				if (res.success)
				{
					$(parent).find('.form__main').hide();
					$(parent).find('.form__success').fadeIn();

					$('.order-table tbody').replaceWith(res.html);
					$('.total_sum').text('$' + res.total);

					$(".order-table tbody [data-popup-open]").on("click", function (e) {
						e.preventDefault();
						let dataPopupName = $(this).attr("data-popup-open");
						let dataPopupClose = $(this).attr("data-popup-close");
						let popup = $(".popup[data-popup-name=" + dataPopupName + "]");

						if (dataPopupClose === "true") {
							$(this).closest(".popup").removeClass("active");
							popup.addClass("active");
						} else {
							$("body").addClass("no-scroll");
							popup.addClass("active");
						}

						// popup YT
						if (dataPopupName === "popup-yt") {
							$(".popup-yt__iframe").attr("src", $(this).attr("href"));
						}

						if (dataPopupName === "popup-service-delete") {
							let tr = $(this).closest('tr');
							let id = tr.attr('data-id');
							let name = tr.find('.order-table__service').text();

							popup.find("input[name=id]").val(id);
							popup.find("input[name=service_name]").val(name);
						}

						if (dataPopupName === "popup-hotel-request") {
							let tr = $(this).closest('tr');
							let id = tr.attr('data-id');

							popup.find('.form__main').show();
							popup.find('.form__success').hide();
							
							popup.find("input[type=hidden][name=id]").val(id);
						}
					});
				}
				else
				{
					alert('Ошибка: ' + res.error);
				}
			},
			error: function(err){
				if (err.statusText === "abort") {
			// Запрос был прерван, можно просто проигнорировать
			console.warn('Запрос был прерван.');
		} else {
			// Обработка остальных ошибок
			alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
		}
			}
		});
	}

	sendCartToEmail(parent)
	{
		let data = $(parent).serialize() + '&action=sendCartToEmail'
		if (this.share_code)
		{
			data += '&share_code=' + this.share_code;
		}

		$.ajax({
			url: "/ajax.php?mid=31",
			type: 'POST',
			data: data,
			dataType: "json",
			success: function(res){
				if (res.success)
				{
					$(parent).find('.form__main').hide();
					$(parent).find('.form__success').fadeIn();

				}
				else
				{
					alert('Ошибка: ' + res.error);
				}
			},
			error: function(err){
				if (err.statusText === "abort") {
			// Запрос был прерван, можно просто проигнорировать
			console.warn('Запрос был прерван.');
		} else {
			// Обработка остальных ошибок
			alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
		}
			}
		});
	}

	makeOrder(parent)
	{
		let _this = this;
		
		$.ajax({
			url: "/ajax.php?mid=31",
			type: 'POST',
			data: $(parent).serialize() + '&action=makeOrder',
			dataType: "json",
			success: function(res){
				if (res.need_code)
				{
					$("body").addClass("no-scroll");
					$('.popup-auth-code-order .popup-auth__card--phone_number').text(parent.str_phone.value);
					$('.popup-auth-code-order').addClass("active");
					auth.startTimer();
				}
				else if (res.success)
				{
					let href = '/order?step=2';
					if (_this.share_code)
					{
						href += '&share_code=' + _this.share_code;
					}
					location.href = href;
				}
				else
				{
					alert('Ошибка: ' + res.error);
				}
			},
			error: function(err){
				if (err.statusText === "abort") {
			// Запрос был прерван, можно просто проигнорировать
			console.warn('Запрос был прерван.');
		} else {
			// Обработка остальных ошибок
			alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
		}
			}
		});
	}

	loadCalendar()
	{
		let fromDate = $('.settings-calendar__day-cell button').last().val();
		$.ajax({
			url: "/ajax.php?mid=3",
			type: 'POST',
			data: {
				action: 'loadCalendar',
				fromDate: fromDate
			},
			dataType: "html",
			success: function(html){
				$('ul.settings-calendar__month-list').append(html);
			},
			error: function(err){
				if (err.statusText === "abort") {
			// Запрос был прерван, можно просто проигнорировать
			console.warn('Запрос был прерван.');
		} else {
			// Обработка остальных ошибок
			alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
		}
			}
		});
	}

	anotherMan(parent)
	{
		if ($(parent).prop('checked') == true)
		{
			$('#another_man_block').fadeIn();
			$('#another_man_block input').prop('disabled', false);
		}
		else
		{
			$('#another_man_block').hide();
			$('#another_man_block input').prop('disabled', true);
		}
	}

	sameName()
	{
		$('input[name="traveler_str_firstname"]').val($('input[name="str_firstname"]').val());
		$('input[name="traveler_str_lastname"]').val($('input[name="str_lastname"]').val());
		$('input[name="traveler_str_phone"]').val($('input[name="str_phone"]').val());
		$('input[name="traveler_str_email"]').val($('input[name="str_email"]').val());
	}

	checkSameName()
	{
		$('.order__block-main:last input[name^="traveler_"]').each(function(){
			let name = $(this).attr('name').replace(/traveler_/, '');
			if ($('input[name="' + name + '"]').val() != $(this).val())
			{
				$('#order_same').prop('checked', false);
			}
		});
	}

	shareCart()
	{
		$.ajax({
			url: "/ajax.php?mid=31",
			type: 'POST',
			data: {
				action: 'shareCart'
			},
			dataType: "json",
			success: function(res){
				$('.order-table__share-list li button[data-copy]').each(function(){
					let val = $(this).attr('data-copy');
					$(this).attr('data-copy', val.replace(/__shared_url__/, res.shareLink));
				});
				$('.order-table__share-list li a[href]').each(function(){
					let val = $(this).attr('href');
					$(this).attr('href', val.replace(/__shared_url__/, res.shareLink));
				});
			},
			error: function(err){
				if (err.statusText === "abort") {
				// Запрос был прерван, можно просто проигнорировать
					console.warn('Запрос был прерван.');
				} else {
					// Обработка остальных ошибок
					alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
				}
			}
		});
	}

	applyEvents(block = null)
	{
		// Swiper
		$('.hotel-card').each(function () {
			let hotelCardThumbs = new Swiper($(this).find(".hotel-card-thumbs")[0], {
				spaceBetween: 8,
				slidesPerView: 5,
				watchSlidesProgress: true,
			});
			let hotelCardSlider = new Swiper($(this).find(".hotel-card-slider")[0], {
				modules: [Thumbs, EffectFade],
				spaceBetween: 8,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				thumbs: {
					swiper: hotelCardThumbs,
					autoScrollOffset: 1,
				},
			});
		});

		$(".hotel-card__link").on("click", function (e) {
			var callbackPopup = $(".hotel-card-thumbs__item");
			if (callbackPopup.is(e.target) || callbackPopup.has(e.target).length !== 0) {
				e.preventDefault();
			};
		});

		const hotelFirst = document.querySelector('.hotel-first')
		if (hotelFirst) {
			let hotelFirstThumbs = new Swiper(".hotel-first-thumbs", {
				spaceBetween: 8,
				slidesPerView: "auto",
				watchSlidesProgress: true,
				breakpoints: {
					768: {
						spaceBetween: 12,
					},
					1224: {
						spaceBetween: 16,
					},
				}
			});
			let hotelFirstSlider = new Swiper(".hotel-first-slider", {
				modules: [Thumbs, EffectFade],
				spaceBetween: 8,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				thumbs: {
					swiper: hotelFirstThumbs,
					autoScrollOffset: 1,
				},
			});
		}


		$('.room-card').each(function () {
			let roomCardThumbs = new Swiper($(this).find(".room-card-thumbs")[0], {
				spaceBetween: 8,
				slidesPerView: 5,
				watchSlidesProgress: true,
			});
			let roomCardSlider = new Swiper($(this).find(".room-card-slider")[0], {
				modules: [Thumbs, EffectFade],
				spaceBetween: 8,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				thumbs: {
					swiper: roomCardThumbs,
					autoScrollOffset: 1,
				},
			});
		});

		const popupGallery = document.querySelector('.popup-gallery');
		const popupGallerySliderList = document.querySelector('.popup-gallery-slider__list');
		const popupGalleryThumbsList = document.querySelector('.popup-gallery-thumbs__list');
		let popupGalleryThumbs = null;
		let popupGallerySlider = null;

		
		$(".room-card-slider__item-container").on("click", function (e) {
			e.preventDefault();

			let roomCardImagesSrcArr = $(this).closest(".room-card-slider").find(".room-card-slider__item-image").map(function () {
				return $(this).attr("src");
			}).toArray();
			let roomCardImagesSrcsetArr = $(this).closest(".room-card-slider").find(".room-card-slider__item-image").map(function () {
				return $(this).attr("srcset");
			}).toArray();

			let roomCardImagesSrcArrBig = roomCardImagesSrcArr.map(function (item) {
				return item.replaceAll("small_", "");
			});
			let roomCardImagesSrcsetArrBig = roomCardImagesSrcsetArr.map(function (item) {
				return item.replaceAll("small_", "");
			});

			let indexOfClickedCard = $(this).closest(".room-card-slider__item").index();

			$("body").addClass("no-scroll");
			$(".popup-gallery").addClass("active");

			popupGallerySliderList.innerHTML = roomCardImagesSrcArrBig.map(function (roomCardImageSrcBig, i) {
				return '<li class="popup-gallery-slider__item swiper-slide"><img class="popup-gallery-slider__item-image" src="' + roomCardImageSrcBig + '" srcset="' + roomCardImagesSrcsetArrBig[i] + '"></li>';
			}).join('');
			popupGalleryThumbsList.innerHTML = roomCardImagesSrcArr.map(function (roomCardImageSrc, i) {
				return '<li class="popup-gallery-thumbs__item swiper-slide"><div class="popup-gallery-thumbs__item-container"><img class="popup-gallery-thumbs__item-image" src="' + roomCardImageSrc + '" srcset="' + roomCardImagesSrcsetArr[i] + '"></div></li>';
			}).join('');

			popupGalleryThumbs = new Swiper(".popup-gallery-thumbs", {
				initialSlide: indexOfClickedCard,
				spaceBetween: 8,
				slidesPerView: "auto",
				watchSlidesProgress: true,
			});
			popupGallerySlider = new Swiper(".popup-gallery-slider", {
				initialSlide: indexOfClickedCard,
				modules: [Thumbs, EffectFade],
				spaceBetween: 8,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				thumbs: {
					swiper: popupGalleryThumbs,
					autoScrollOffset: 1,
				},
			});
		});


		$(".popup__close, .popup__cancel").on("click", function (e) {
		// popup gallery
			if ($(this).closest(".popup").hasClass("popup-gallery")) {
				popupGalleryThumbs.destroy(true, true);
				popupGallerySlider.destroy(true, true);
				popupGallerySliderList.innerHTML = "";
				popupGalleryThumbsList.innerHTML = "";
			}
		});

		$(".popup").on("click", function (e) {
			var callbackPopup = $(".popup__card")
			if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
				$(this).removeClass("active");
				$("body").removeClass("no-scroll");

		// popup gallery
				if ($(this).hasClass("popup-gallery")) {
					popupGalleryThumbs.destroy(true, true);
					popupGallerySlider.destroy(true, true);
					popupGallerySliderList.innerHTML = "";
					popupGalleryThumbsList.innerHTML = "";
				}
			};
		});

		document.addEventListener("keypress", function onEvent(e) {
			if (e.key === "Escape") {
				if ($(".popup").hasClass("active")) {
					e.preventDefault();
		// popup gallery
					if ($(".popup-gallery").hasClass("active")) {
						popupGalleryThumbs.destroy(true, true);
						popupGallerySlider.destroy(true, true);
						popupGallerySliderList.innerHTML = "";
						popupGalleryThumbsList.innerHTML = "";
					}

					$(".popup").removeClass("active");
					$("body").removeClass("no-scroll");
				}
			}
		});
	}
}